import { render, staticRenderFns } from "./dataV4.vue?vue&type=template&id=43175b61&scoped=true&"
import script from "./dataV4.vue?vue&type=script&lang=js&"
export * from "./dataV4.vue?vue&type=script&lang=js&"
import style0 from "./dataV4.vue?vue&type=style&index=0&id=43175b61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43175b61",
  null
  
)

export default component.exports